"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _InputLabel2 = _interopRequireDefault(require("@material-ui/core/InputLabel"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _InputLabel3 = _interopRequireDefault(require("./InputLabel.styles"));

var InputLabel = /*#__PURE__*/(0, _react.forwardRef)(function InputLabel(props, ref) {
  // don't pass the required prop to avoid adding an * symbol, not in Propulsion specs
  var children = props.children,
      className = props.className,
      required = props.required,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["children", "className", "required"]);
  var classes = (0, _InputLabel3.default)();
  return /*#__PURE__*/_react.default.createElement(_InputLabel2.default, Object.assign({}, otherProps, {
    className: (0, _classnames.default)('pds-input-label', className),
    classes: classes,
    disableAnimation: true,
    ref: ref,
    shrink: false
  }), children, required ? '' : ' (Optional)');
});
InputLabel.propTypes = {
  /**
   * The contents of the `InputLabel`.
   */
  children: _propTypes.node,

  /**
   * The CSS class name applied to the root node.
   */
  className: _propTypes.string,

  /**
   * If `true`, apply disabled class.
   */
  disabled: _propTypes.bool,

  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: _propTypes.bool,

  /**
   * if `true`, the label will indicate that the input is required.
   */
  required: _propTypes.bool
};
var _default = InputLabel;
exports.default = _default;
